import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operating-data",
  "use": "icon-operating-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-operating-data\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64.5C264.9 64.5 64.5 264.9 64.5 512S264.9 959.5 512 959.5 959.5 759.1 959.5 512 759.1 64.5 512 64.5z m0 831.1c-211.5 0-383.6-172.1-383.6-383.6S300.5 128.4 512 128.4 895.6 300.5 895.6 512 723.5 895.6 512 895.6z\" p-id=\"17805\" /><path d=\"M512 256.3h-63.9v319.6h319.6V512H512z\" p-id=\"17806\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operating-data.svg
// module id = zoyW
// module chunks = 3